import React, { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { validateWeight } from '../../util/validation';
import { useValidationWarningStyles } from '../../util/styles';

const WeightOverride = ({ overrideChange, currentValue, columnKey }) => {
  const classes = useValidationWarningStyles();
  const [warning, setWarning] = useState(validateWeight(currentValue));

  const handleChange = e => {
    const value = e.target.value;
    overrideChange(columnKey, value);
    setWarning(validateWeight(value));
  };

  return (
    <div>
      <TextField
        type="number"
        label="Weight (kg)"
        value={currentValue || ''}
        onChange={handleChange}
        inputProps={{
          step: 1,
          min: 0,
        }}
      />
      {warning && <Typography className={classes.warningText}>{warning}</Typography>}
    </div>
  );
};

export { WeightOverride };
